import { Hook } from "@oclif/core"
import * as console from "node:console"

import { BaseCommand } from "../../types/index.js"

const hook: Hook<"prerun"> = async function ({ Command }) {
  if (Command && Command.prototype instanceof BaseCommand) {
    // const { commandId, configSchema } = new (Command as never)()
    try {
      // const configService = ConfigService.getInstance()
      // const fileConfig = configService.getCommandConfig(commandId, configSchema) as {
      //   [key: string]: boolean | number | string | undefined
      // }
      // if (Command.flags) {
      // for (const [flagName, flagDef] of Object.entries(Command.flags)) {
      // If the flag is marked as required but exists in config
      // if (flagDef.required && fileConfig && flagName in fileConfig && fileConfig[flagName] !== undefined) {
      //   // Make it not required since we'll use the config value
      //   flagDef.required = false
      // }
      // }
      // }
    } catch {
      console.log("Cannot apply configuration from .supernova.json")
    }
  }
}

export default hook
